// contactform.js
import 'select2';

import $ from 'jquery';

import presetApplication from './application-of-interest'

import './select2custom'

(function () {

    $(document).ready(() => {

        const referrer = $('input[name="referrer"]').val()

        $('a.franchise-step-1').on('click', goToStep1)

        $('a.franchise-next-step').on('click', goToStep2)

        $("#hero-form-step-1 [type=submit], #hero-form-step-2 [type=submit]").on('click', function () {
            $(this).attr("clicked", "true");
        });

        $('#hero-form-step-1, #hero-form-step-2').on('submit', function (e) {

            const form = $(this);

            let target = e.currentTarget

            e.preventDefault();

            $(document).find('.error.postnumber-error').remove()

            const btn = $(this).find("[type=submit][clicked=true]");

            btn.removeAttr('clicked')

            btn.prop("disabled", true);

            const postAction = form.find('input[name="action"]').val()

            $.ajax({
                url: ajaxurl,
                type: 'post',
                data: {
                    action: 'get_district_from_post',
                    place: $('#place-registration-of-interest').val(),
                    quick_search: true,
                    referrer: referrer,
                    post_action: postAction
                },

                error: function (response) {
                    console.log(response)
                },

                success: function (response) {

                    const parent = form.find('#place-registration-of-interest').parent().parent()

                    parent.removeClass('error')

                    if (parent.find('small.error').length) {
                        parent.find('small.error').remove()
                    }

                    if (response['#quick-search']) {


                        if (response.status === 'success') {

                            $(document).on('click', 'a.quick-search-change-office', function (e) {

                                e.preventDefault()

                                const val = $(e.target).text()

                                // dont validate if not final step
                                if (!btn.hasClass('final')) {
                                    form.append('<input type="hidden" name="initial_post" value="true"/>')
                                }

                                $(document).find('[name="place-registration-of-interest"]').val(val)

                                form.attr('action', $(e.target).attr('href'));

                                target.submit()
                            })

                            if ($('#quick-search').length) {
                                $('#quick-search').replaceWith(response['#quick-search'])
                            } else {
                                btn.before(response['#quick-search'])
                            }

                        }

                    }

                    else {

                        if (response.status === 'success') {

                            // dont validate if not final step
                            if (!btn.hasClass('final')) {
                                form.append('<input type="hidden" name="initial_post" value="true"/>')
                            }

                            form.attr('action', response.value);

                            target.submit()

                        }

                        if (response.status === 'error') {

                            parent.addClass('error')

                            if (response.message) {

                                parent.append('<small class="error">' + response.message + '</small>')
                            }

                        }

                    }

                    btn.prop("disabled", false);

                }

            });

        })


        const forms = [
            {
                dropDownElement: $('.top-form.new-layout-form .service-contact'), // hero default top
                placeholder: "Vilken typ av tjänst behöver du hjälp med?"
            },
            {
                dropDownElement: $('.contact-form-service-page.new-layout-form .service-contact'), // service page in content flow example /tjanst/butikspersonal/ 
                placeholder: "Vilken typ av tjänst behöver du hjälp med?",
                hidden: true
            },

            {
                dropDownElement: $('.application-form.new-layout-form .service-contact'), // /intresseanmalan
                placeholder: "Vilken typ av tjänst behöver du hjälp med?",
            },

        ]

        for (const f of forms) {
            presetApplication(f)
        }

        // presetApplication({
        //     dropDownElement: $('.top-form.new-layout-form .service-contact'),
        //     placeholder: "Vilken typ av tjänst behöver du hjälp med?"
        // })

        // presetApplication({
        //     dropDownElement: $('.application-form.new-layout-form .service-contact'),
        //     placeholder: "Vilken typ av tjänst behöver du hjälp med?"
        // })



        // presetApplication({
        //     dropDownElement: $('.recruitment-form.new-layout-form .service-contact'),
        //     placeholder: "Vilken typ av tjänst behöver du hjälp med?"
        // })

        // presetApplication({
        //     dropDownElement: $('.post-top-work.new-layout-form .service-contact'),
        //     placeholder: "Vilken typ av tjänst behöver du hjälp med?"
        // })


        function goToStep1(e) {

            e.preventDefault()

            $('.contact-form .step-1-content').show()
            $('.contact-form .step-2-content').hide()
        }

        function goToStep2(e) {
            e.preventDefault()

            const phoneElement = $('.contact-form-franchise #contact-phone')
            const emailElement = $('.contact-form-franchise #contact-email')
            const formError = $('.contact-form-franchise .form-error-msg')

            formError.hide()

            if (phoneElement[0].checkValidity() && emailElement[0].checkValidity()) {
                $('.contact-form-franchise .step-1-content').hide()
                $('.contact-form-franchise .step-2-content').show()
            } else {
                formError.html('Var god fyll i e-postadress eller telefonnummer.')
                formError.show()
            }
        }

    })
})()




